import { jsx as s, jsxs as i } from "react/jsx-runtime";
function o({
  className: t,
  children: e
}) {
  const n = "shadow overflow-hidden sm:rounded-lg " + (t || "");
  return /* @__PURE__ */ s("div", { className: n, children: /* @__PURE__ */ s("dl", { children: e }) });
}
function r({
  children: t
}) {
  return /* @__PURE__ */ s("dd", { className: "mt-1 text-sm text-gray-900 dark:text-gray-300 sm:mt-0 sm:col-span-2", children: t });
}
function a({ children: t }) {
  return /* @__PURE__ */ s("dt", { className: "text-sm font-medium text-gray-500 dark:text-gray-200", children: t });
}
function d({
  label: t,
  children: e
}) {
  return /* @__PURE__ */ i("div", { className: "p-2 bg-gray-50 dark:bg-stone-800 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6", children: [
    /* @__PURE__ */ s(a, { children: t }),
    /* @__PURE__ */ s(r, { children: e })
  ] });
}
export {
  o as D,
  d as a,
  a as b,
  r as c
};
